// Time-based greetings and random motivational phrases

const MOTIVATIONAL_PHRASES = [
  // Sports & Competition
  "Go get 'em, tiger!",
  'Time to play ball!',
  'Swing for the fences!',
  "You're up to bat!",
  'Hit it out of the park!',
  "Let's score some runs!",
  "It's game time!",
  'Time to step up to the plate!',
  'Knock it out of the park!',
  'Home run day incoming!',
  "You're in the starting lineup!",
  'Champions play every day!',
  'MVP energy today!',
  'All-star mode: activated!',
  "The crowd's cheering for you!",

  // Action & Energy
  "Let's do this!",
  'Time to make moves!',
  'Ready to crush it?',
  "Let's make things happen!",
  'Full speed ahead!',
  'Charge into the day!',
  'Hit the ground running!',
  "Let's rock and roll!",
  'Fire it up!',
  'Go time!',
  'Attack the day!',
  'Seize the moment!',
  'Make it count!',
  "Let's get after it!",
  'Time to shine!',

  // Encouragement & Confidence
  "You've got this!",
  "Today's your day!",
  'Believe in yourself!',
  "You're unstoppable!",
  'Nothing can stop you!',
  "You're on fire!",
  'Keep that momentum going!',
  'Trust the process!',
  "You're built for this!",
  'Your time is now!',
  'Own this day!',
  "You're a closer!",
  'Success is calling!',
  'The world is yours!',
  'Excellence awaits!',

  // Hustle & Grind
  "Let's hustle!",
  'Grind mode: ON',
  'Time to put in the work!',
  'Outwork everyone!',
  'Rise and grind!',
  'Stay hungry!',
  'Never settle!',
  'Keep pushing!',
  'One deal at a time!',
  'Every call counts!',
  'Consistency wins!',
  'Stack those wins!',
  'Build your empire!',
  'Fortune favors the bold!',
  'Earn it today!',

  // Real Estate Specific
  'Keys to success await!',
  'Open doors today!',
  'Close some deals!',
  'Your pipeline is hot!',
  'Listings are waiting!',
  'Dream homes need you!',
  'Be their trusted advisor!',
  'Make homeownership happen!',
  'Connect buyers to dreams!',
  "You're the market expert!",
  'Location, location, motivation!',
  'Sold signs incoming!',
  'Commission check loading...',
  'Referrals are earned today!',
  'Your reputation grows daily!',

  // Positivity & Mindset
  'Great things are coming!',
  'Stay positive, stay productive!',
  'Good vibes only!',
  'Radiate confidence!',
  'Smile and dial!',
  'Positive energy attracts!',
  'Be the sunshine!',
  'Optimism is your superpower!',
  'Grateful and motivated!',
  'Today is full of possibilities!',
  'Abundance mindset activated!',
  'Opportunities everywhere!',
  'See the potential!',
  'Every contact is a chance!',
  'Your attitude is everything!',

  // Short & Punchy
  "Let's go!",
  'Bring it!',
  'Showtime!',
];

/**
 * Get a random motivational phrase
 * Uses the current date as a seed so the same phrase shows all day
 */
export function getRandomMotivationalPhrase(): string {
  // Use date as seed so phrase stays consistent throughout the day
  const today = new Date();
  const seed = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();
  const index = seed % MOTIVATIONAL_PHRASES.length;
  return MOTIVATIONAL_PHRASES[index];
}

/**
 * Get a truly random phrase (changes on each call)
 */
export function getRandomPhrase(): string {
  const index = Math.floor(Math.random() * MOTIVATIONAL_PHRASES.length);
  return MOTIVATIONAL_PHRASES[index];
}

/**
 * Get the time-based greeting
 */
export function getTimeBasedGreeting(name?: string): string {
  const hour = new Date().getHours();
  const displayName = name?.split(' ')[0] || 'there';

  if (hour >= 5 && hour < 12) {
    return `Good morning, ${displayName}!`;
  } else if (hour >= 12 && hour < 17) {
    return `Good afternoon, ${displayName}!`;
  } else if (hour >= 17 && hour < 21) {
    return `Good evening, ${displayName}!`;
  } else {
    // 9pm - 5am
    return 'Burning the midnight oil?';
  }
}

/**
 * Get both greeting and motivational phrase
 */
export function getDailyGreeting(name?: string): { greeting: string; phrase: string } {
  return {
    greeting: getTimeBasedGreeting(name),
    phrase: getRandomMotivationalPhrase(),
  };
}
